export default {"src":"/_next/static/media/Roller.e89e903d.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};